module.exports = __webpack_public_path__ + "img/aiconbj.57a532f9.png";